// extracted by mini-css-extract-plugin
module.exports = {"information":"style_information__1JkiU","wrapper":"style_wrapper__zCGqK","sub_page":"style_sub_page__1vru7","sections":"style_sections__10GBP"};